import type { AudioSource } from "@yetric/audioplayer";
import { getPodcastImage, ImageSizes } from "@/core/helpers";

/** What the audio player needs to load an episode */
export const toAudioSource = (episode: Episode, podcast: Podcast): AudioSource => ({
    id: episode.id.toString(),
    src: episode.sound,
    title: episode.title,
    artist: podcast.name,
    album: podcast.name,
    artwork: getPodcastImage(podcast, ImageSizes.Medium),
});
